import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import Box from 'features/Hotel/Box'
import { useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import hotelSetupApi from 'services/api/hotelSetup'
import userApi from 'services/api/user'

import styles from './SendACHForm.module.scss'

const SendACHForm = ({ achContractSigned }) => {
  const { addToast } = useToasts()

  const [users, setUsers] = useState([])
  const [selectedUserId, setSelectedUserId] = useState()

  function sendACHForm() {
    hotelSetupApi
      .sendAchForm({
        userId: selectedUserId
      })
      .then(() => {
        addToast('ACH form sent successfully.', {
          appearance: 'success',
          autoDismiss: true
        })
      })
      .catch(() => {
        addToast('Something went wrong. Please try again later.', {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }

  useEffect(() => {
    userApi
      .getList()
      .then(res => {
        setUsers(res.users.filter(u => !u.isInternalGlobalUser))
      })
      .catch(() => {
        addToast('Something went wrong. Please try again later.', {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }, [addToast])

  return (
    <div className={styles.wrapper}>
      <Box title="ACH Auth Form">
        {achContractSigned ? (
          <p className={styles.alreadySigned}>ACH Auth Form already signed</p>
        ) : (
          <>
            <Dropdown
              className={styles.dropdown}
              disabled={users.length === 0}
              defaultVal={users.length === 0 ? 'No users to send' : 'Select user'}
              options={users.reduce(
                (prev, current) => ({ ...prev, [current.userId]: current.name }),
                {}
              )}
              value={selectedUserId}
              onChange={e => setSelectedUserId(e.target.value)}
            />
            <PrimaryRegularButton
              disabled={!selectedUserId}
              className={styles.primaryButton}
              onClick={sendACHForm}
            >
              Send ACH Auth Form
            </PrimaryRegularButton>
          </>
        )}
      </Box>
    </div>
  )
}

export default SendACHForm
